
import {Component, Prop, Vue} from "vue-property-decorator";
import IComptage from "@/types/comptage.interface";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";

@Component({
    components: {TooltipDialog}
})
export default class AdvancedFilterComptage extends Vue {

    @Prop() readonly product: IComptage;
    @Prop() readonly loadingFilter: boolean;

}
